import { useRouter } from 'vue-router'

import { getActiveClubId } from './useActiveClub.js'

export function useClubRouter() {
  const router = useRouter()

  /**
   * Add activeClubId and respect append behaviour
   * @param {string|object} to - Route definition
   * @param {boolean} append - Whether to append path (relative)
   * @returns {string|object}
   */
  function addClubIdToRoute(to, append = false) {
    const activeClubId = getActiveClubId()

    const resolved = router.resolve(to, undefined, append)

    if (!activeClubId) {
      return resolved
    }

    const url = new URL(resolved.href, window.location.origin)
    url.searchParams.set('activeClubId', activeClubId)

    return url.pathname + url.search
  }

  return {
    push: (to, opts = {}) => {
      const routeWithClubId = addClubIdToRoute(to, opts.append)
      return router.push(routeWithClubId)
    },
    replace: (to, opts = {}) => {
      const routeWithClubId = addClubIdToRoute(to, opts.append)
      return router.replace(routeWithClubId)
    },
    go: n => router.go(n),
    back: () => router.back(),
    options: router.options,
    currentRoute: router.currentRoute,
    afterEach: router.afterEach,
    beforeEach: router.beforeEach,
  }
}
